import { render, staticRenderFns } from "./WidgtesMenu.vue?vue&type=template&id=2afd44f5&scoped=true&"
import script from "./WidgtesMenu.vue?vue&type=script&lang=ts&"
export * from "./WidgtesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./WidgtesMenu.vue?vue&type=style&index=0&id=2afd44f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd44f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VLayout})
